<template>
  <div class="execution">
    <el-drawer
      size="890px"
      title="结算卡交卡回执单"
      :data="visible"
      :visible.sync="visible"
      :before-close="cancelModal"
      :wrapperClosable="false"
      center
    >
      <!-- <basic-container> -->
      <!-- <el-collapse
          v-model="activeNames"
          v-for="(item, index) in lists"
          :key="index"
        >
          <el-collapse-item :title="'交卡回执：' + item.receipt" :name="index"> -->
      <div
        class="dialogContent"
        :ref="'print' + (index + 1)"
        v-for="(item, index) in lists"
        :key="index"
      >
        <div class="dialogTitle">
          <img src="@/static/zflogo.png" alt="" />
          <span style="border-bottom: 1px solid #313133">
            <span>{{ item.companyAuthName }}</span></span
          >
          <span class="desc">结算卡交卡回执单</span>
        </div>

        <div class="table">
          <!-- <div class="tableTitle">
                <span>承运人:</span><span class="red">共计车，元</span>
              </div> -->

          <div class="inner">
            <div class="tableTitle">
              <div class="left">
                <div class="label">交卡回执单号</div>
                <div class="value">{{ item.giveCardNo }}</div>
              </div>
              <div class="right">
                <div class="label">交卡人</div>
                <div class="value">{{ item.giveCardUserId }}</div>
              </div>
              <!-- <span>交卡回执单号:{{ item.giveCardNo }}</span
              ><span>交卡人:{{ item.giveCardUserId }}</span> -->
            </div>
            <el-table :data="item.list" border class="table">
              <el-table-column
                property="cardType"
                label="卡类型"
              ></el-table-column>
              <el-table-column
                property="settleCardNo"
                label="结算卡号"
              ></el-table-column>
              <el-table-column
                property="projectName"
                label="项目名称"
              ></el-table-column>
              <!-- <el-table-column
                    property="perPrice"
                    label="单价"
                  ></el-table-column> -->
              <el-table-column
                property="giveCardCnt"
                label="运单总数"
              ></el-table-column>
              <el-table-column
                property="giveCardDatetime"
                label="交卡日期"
              ></el-table-column>
            </el-table>
            <div class="tableTitle bottom">
              <span>合计:</span><span> {{ getTotal(item.list) }}</span>
            </div>
          </div>
        </div>
        <ul class="info">
          <div class="left">
            <div class="label">甲方签名：</div>
            <div class="value">日期：</div>
          </div>
          <div class="right">
            <div class="label">乙方签名：</div>
            <div class="value">日期：</div>
          </div>
        </ul>
        <div class="btns">
          <el-button
            size="small"
            type="primary"
            plain
            @click="downExport(item.giveCardNo)"
            >导出Excel</el-button
          >
          <el-button
            size="small"
            :loading="btnLoading"
             type="primary"
            plain
            @click="print(item.giveCardNo)"
            >下载PDF打印</el-button
          >
        </div>
      </div>

      <!-- </el-collapse-item>
        </el-collapse> -->
      <!-- </basic-container> -->
    </el-drawer>
  </div>
</template>

<script>
import { expotOut } from "@/util/down.js";
import { getCardReceipt, downloadReceiptPdf } from "@/api/chain/companysettle";
export default {
  name: "generateCardReceipt",
  components: {},
  props: {
    cardReceiptList: {
      type: Array,
    },
    visible: {
      type: Boolean,
    },
  },
  data() {
    return {
      lists: [],
      // cardReceiptList: [],
      selectGenerateCardReceiptList: [],
      activeNames: [0],
      accountForm: {},
      btnLoading: false,
    };
  },
  created() {},
  mounted: function () {
    // this.cardReceiptList = this.$route.query.cardInfo;
    this.getData();
  },
  computed: {},
  methods: {
    getTotal(list) {
      return list.reduce((pre, cur) => {
        return pre + cur.giveCardCnt;
      }, 0);
    },
    cancelModal() {
      this.$emit("update:visible", false);
    },
    getData() {
      getCardReceipt(this.cardReceiptList).then((res) => {
        this.lists = res.data.data;
      });
    },
    //导出
    downExport(giveCardNo) {
      let params = {
        giveCardNo: giveCardNo,
        code: "CompanyCardGiverExcelExport",
      };
      let url = "/chain/excelExport/createByCode";
      expotOut(params, url, "交卡回执单");
    },
    print(giveCardNo) {
      this.btnLoading = true;
      downloadReceiptPdf(this.cardReceiptList)
        .then((res) => {
          console.log(res);
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          let fileName = "交卡回执单.pdf"; //
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          this.btnLoading = false;
        })
        .catch((err) => {
          this.btnLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.info {
  display: flex;
  justify-content: space-between;
  // border-bottom: 1px solid #ccc;
  // padding-bottom: 10px;
  margin: 40px 0;
  padding: 0 20px;
  margin-bottom: 26px;
  .left,
  .right {
    font-weight: 400;
    font-size: 14px;
    color: #313133;
    .label {
      font-weight: 500;
      font-size: 16px;
      color: #313133;
      margin-bottom: 14px;
    }
    .value {
      font-weight: 400;
      font-size: 14px;
      color: #313133;
    }
  }
  li {
    text-align: left;
    margin-left: 20px;
    width: 50%;
    font-weight: 400;
    font-size: 14px;
    color: #313133;
    margin-bottom: 14px;
    label {
      display: inline-block;
      width: 96px;
    }
    span {
      color: #666;
    }
  }
}
.tableTitle {
  // border: 1px solid #9a9a9a;
  margin-left: 1px;
  border-bottom: none;
  line-height: 32px;
  padding: 20px;
  // color: #606266;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .left,
  .right {
    .label {
      font-weight: 400;
      font-size: 14px;
      color: #313133;
      // margin-bottom: 5px;
    }
    .value {
      font-weight: 500;
      font-size: 18px;
      color: #313133;
    }
  }
  &.bottom {
    height: 48px;
    border-top: none;
    border-bottom: 1px solid #edeff0;
    padding: 0 24px;
    font-weight: 400;
    font-size: 14px;
    color: #313133;
  }
}
.red {
  color: red;
}

/deep/ .el-table {
  border-bottom: 0.5px solid #edeff0;
  border-right: 0.5px solid #edeff0;
  tr {
    .el-table__cell {
      border-left: 0.5px solid #edeff0 !important;
      // border-top: .5px solid #edeff0;
    }
    border-right: 0.5px solid #edeff0 !important;
  }
  .el-table__row {
    td {
      padding: 4px 0px;
    }
  }
  .el-table__header {
    th {
      padding: 4px 0px;
    }
  }
}
.dialogContent {
  border: 1px solid #edeff0;
  margin: 32px;
  margin-bottom: 100px;
  // border: 1px solid #ccc;
  // margin-bottom: 30px;
  .dialogTitle {
    font-weight: 500;
    font-size: 20px;
    color: #313133;
    text-align: center;
    height: 65px;
    line-height: 65px;
    border-bottom: 2px solid #999999;
    // border-bottom: 1px solid #ccc;
    // margin-bottom: 20px;
    position: relative;
    img {
      position: absolute;
      left: 20px;
      top: 20px;
      width: 78px;
      height: 28px;
    }
    .desc {
      font-weight: 400;
      font-size: 20px;
      color: #313133;
      margin-left: 10px;
    }
  }
  .myTable {
    padding: 0 10px;
  }
}
.total {
  margin-top: 40px;
  background-color: #f2f2f2;
  color: #333;
  font-weight: 700;
  line-height: 40px;
  text-align: center;
}
.btn {
  margin-top: 30px;
  text-align: center;
}
/deep/.el-drawer__header {
  border-bottom: 1px solid #ededf0;
  padding-bottom: 20px;
  font-weight: 400;
  font-size: 14px;
  color: #313133;
  margin-bottom: 0;
}
/deep/ .el-table__header th.is-leaf {
  background: #f5f8fa !important;
}
.footer {
  padding: 16px 24px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-top: 1px solid #ededf0;
  background: #fff;
}
.btns{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px 24px;
  padding-top: 0;
  /deep/.el-button{
    background: #fff;
    &:hover{
      color: #35B1FF;
    }
  }
}
</style>
